import LazyImage from "@Components/Image";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./AgentQRSection.module.scss";
import { getUtmReferrer, getUtmSourceFromCookie } from "helpers/getWeComUrlBasedOnSource";
import useIsDesktop from "hooks/useIsDesktop";
import isMiniProgramUserAgent from "@Utils/isMiniProgramUserAgent";
import config from "@Config/index";
import { useSelector } from "react-redux";
import { AppState } from "@Store/index";

const utmReferrer = getUtmReferrer();
const utmSourceCookie = getUtmSourceFromCookie();

const AgentQRSection = () => {
  const isDesktop = useIsDesktop();

  const { utmSource } = useSelector(({ appData }: AppState) => ({
    utmSource: appData.UtmDetails?.utm_source,
  }));

  const getWeChatQrBasedOnUtm = () => {
    let imageURL = isDesktop
      ? `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-direct.png`
      : `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-mobile-direct.png`;

    if (isMiniProgramUserAgent()) {
      imageURL = `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-miniprogram.png`;
    }
    if (utmSource?.includes("baidu_ads") || utmSourceCookie?.includes("baidu_ads")) {
      imageURL = isDesktop
        ? `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-baidu-ads.png`
        : `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-mobile-baidu-ads.png`;
    }
    if (utmReferrer.includes("baidu") && utmSource === "") {
      imageURL = isDesktop
        ? `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-baidu-organic.png`
        : `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-mobile-baidu-organic.png`;
    }
    if (utmSource === "google_ads_cn" || utmSource === "google_adwords") {
      imageURL = isDesktop
        ? `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-google-ads.png`
        : `${config.IMAGE_STATIC_URL}/images/amber-wechat-qr-mobile-google-ads.png`;
    }
    return imageURL;
  };

  return (
    <div className={styles.container}>
      <LazyImage
        src={getWeChatQrBasedOnUtm()}
        alt="WeChat QR Code"
        className={styles.qrImage}
        width={200}
        height={200}
      />
      <div className={styles.textLine}>扫码添加专属顾问</div>
      <div className={styles.textLine}>免费提供1对1找房服务</div>
    </div>
  );
};

export default wrapperHOC(AgentQRSection, {
  componentName: "AgentQRSection-PropertyPage",
  showForChina: true,
});
